// extracted by mini-css-extract-plugin
module.exports = {"container":"Share-module--container--2QJ50","socialIcon":"Share-module--socialIcon--gitD_"};